import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ClampLines from 'react-clamp-lines';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

import { getLegacySession } from '../../../bridge';
import { formatDate } from '../../../helpers/itpmetricsUtils';
import { getCookieValue, getLanguage } from '../../../helpers/utils';

import './DashboardCard.scss';

function AssessmentCard({ item }) {
  const row = getCookieValue('display-rows');

  const onClick = async () => {
    const { response: { sessionId, url } } = await getLegacySession();
    const language = getLanguage();
    const queryParams = `guid=${item.guid}&ltiSessionId=${sessionId}&language=${language}`;
    const newUrl = `${url}/dashboard?${queryParams}`;
    if (isMobile) {
      window.location.href = newUrl;
    } else {
      window.open(newUrl);
    }
  };

  return row ? (
    <Card
      onClick={onClick}
      className="dashboard-card-row p-2"
    >
      <Row>
        <Col sm={6} md={6} lg={6}>
          <ClampLines
            id={`assessment-title-${item.guid}`}
            text={item.name}
            lines={1}
            buttons={false}
            className="dashboard-card-title"
          />
        </Col>
        <Col>
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.8em',
          }}
          >
            {item.questionnaire_name}
          </div>
        </Col>
        <Col>
          {item.date_scheduled_start && (
            <div style={{
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.7em',
            }}
            >
              {formatDate(item.date_scheduled_start)}
            </div>
          )}
        </Col>
      </Row>
    </Card>
  ) : (
    <Card
      onClick={onClick}
      className="mx-2 my-3 dashboard-card"
    >
      <Card.Body>
        <>
          <ClampLines
            id={`assessment-title-${item.guid}`}
            text={item.name}
            lines={3}
            buttons={false}
            className="dashboard-card-title"
          />
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.8em',
          }}
          >
            {item.questionnaire_name}
          </div>
          {item.date_scheduled_start && (
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.7em',
          }}
          >
            {formatDate(item.date_scheduled_start)}
          </div>
          )}
        </>
      </Card.Body>
    </Card>
  );
}

AssessmentCard.propTypes = {
  item: PropTypes.object,
  row: PropTypes.bool,
};

export default AssessmentCard;
